// extracted by mini-css-extract-plugin
export default {"sprite":"animatedSprite_sprite__V3+Dc","sprite--transition":"animatedSprite_sprite--transition__D66Y1"};